/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autosave_SavedInputs */

const cs_autosave_saved = /** @type {(inputs: Autosave_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uloženo`)
};

const en_autosave_saved = /** @type {(inputs: Autosave_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Autosave_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const autosave_saved = /** @type {((inputs?: Autosave_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autosave_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autosave_saved(inputs)
	return cs_autosave_saved(inputs)
});